import React from "react";
import { connect } from "react-redux";
import { handleErrors } from "../../actions";
import PropTypes from "prop-types";
import green from "@material-ui/core/colors/green";
import classNames from "classnames";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core/styles";

const variantIcon = {
  error: ErrorIcon,
  success: CheckCircleIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          {/* <CloseIcon className={classes.icon} /> */}
        </IconButton>
      ]}
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
  margin: {
    margin: theme.spacing(1)
  }
});

class CustomizedSnackbars extends React.PureComponent {
  handleClose = () => {
    this.props.handleErrors({ message: "", open: false });
    // if (reason === "clickaway") {
    //   return;
    // }
  };

  componentDidUpdate(prevProps) {
    if (this.props.error.open !== prevProps.error.open) {
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={this.props.error.open}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            variant={this.props.error.variant}
            className={classes.margin}
            message={`${this.props.error.message}`}
          />
        </Snackbar>
      </div>
    );
  }
}

CustomizedSnackbars.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  error: state.error
});
export default withStyles(styles2)(
  connect(
    mapStateToProps,
    { handleErrors: handleErrors }
  )(CustomizedSnackbars)
);



// WEBPACK FOOTER //
// ./src/components/common/ErrorMessage.js